<template>
    <div class="wrapper">
        <div class="top-pic">
            <img :src="data.image" alt="">
        </div>

        <!-- 标题区 -->
        <div class="title-area">
            <h3>{{data.viewType=='bigimage' ? (data.showTitle?data.title:'') : (data.showTitle?data.listTitle:data.title) }}</h3>
            <div class="description">{{data.description}}</div>
        </div>
    
        <!-- 专题导航区 -->
        <div class="lable-ul" v-if="data.blockType != 1">
            <div class="label-ul-content">
                <ul>
                    <li v-for="(item, index) in blocks" v-if="blocks && blocks.length">
                        <a href="javascript:void(0);" @click="toggleBlock(index,$event)">{{item.title}}</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 列表区 -->
        <section v-for="(item, index) in blocks" v-if="blocks && blocks.length">
            <header class="flex flex-cross-center" :id=generateElementId(index)>
                <span>{{index+1}}</span>∕<span>{{data.blocks.length}}</span>
                <div class="name">{{item.title}}</div>
            </header>
            <ul>
                <li
                    class="flex flex-main-justify"
                    v-for="article in item.articles"
                    @click="goPath(article)"
                    :key="article.id"
                >
                    
                    <div v-if="article.type === 'live'" style="width:100%">
                        <div class="title"><span class="tag_label" v-if="article.tags  && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                        <!-- liveType直播类型 1有视频无图 2有图无视频 3无图无视频 -->
                        <div class="pic-wrap-2" v-if="article.liveType != 3 && article.images">
                            <img :src="article.images[0]" alt="">
                            <!-- liveStatus || status直播状态 1预告 2直播中 3已结束 -->
                            <div :class="'living-label-' + article.liveStatus"></div>
                        </div>
                        <div class="flex flex-main-justify date">
                            <span>{{getDate(article.date) | dateCompared}}</span>
                            <span v-if="article.hits > 0">{{article.hits}}人参与</span>
                        </div>
                    </div>
                    <!-- 三图 -->
                    <div v-if="article.viewType==='three'" style="height:100%;width:100%;">
                        <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                        <div class="three-list flex">
                            <div class="img" v-for="img in article.images" :key="img" :style="{backgroundImage: 'url(' + img + ')'}"></div>
                            <div class="images-label" v-if="article.type === 'image'">{{article.medias && article.medias.length>0 ?article.medias.length : 0}}图</div>
                        </div>
                        <div class="flex-default date" style='justify-content: flex-start;'>
                            <div class="tag ellipsis">
                                <span 
                                    class="tag-red"  
                                    v-if="article.type !='subject'" v-html="article.tags"
                                ></span>
                                <span v-html="article.source"></span>
                            </div>
                            <time>{{getDate(article.date) | dateCompared}}</time>
                        </div>
                    </div>
                    <div v-else-if="article.viewType==='bannerSmall'" style="width:100%;">
                        <div class="img-frame-small">
                        <div class="img-bac" v-if="article.images" :style="'background:url('+article.images[0]+') no-repeat;background-size:100%'"></div>
                        </div>
                    </div>
                    <div v-else-if="article.viewType==='banner'" style="height:100%;width:100%;">
                        <!-- 新闻 -->
                        <div v-if="article.type === 'normal'">
                            <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                            <div class="pic-wrap">
                                <img :src="article.image" alt="">
                            </div>
                            <!-- <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.title}}</div> -->
                            <div class="description" v-html="article.description"></div>
                            <div class="flex-default date" style='justify-content: flex-start;'>
                                <div class="tag ellipsis" >
                                    <span 
                                        class="tag-red"  
                                        v-if="article.type !='subject'" v-html="article.tags"
                                    ></span>
                                    <span v-html="article.source"></span>
                                </div>
                                <time>{{getDate(article.date) | dateCompared}}</time>
                            </div>
                        </div>
                        <!-- 视频 -->
                        <div v-else-if="article.type === 'video'">
                             <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                            <div class="pic-wrap">
                                <img :src="article.images[0]" alt="">
                                <i class="content-button"></i>
                            </div>
                            <!-- <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.title}}</div> -->
                            <div class="flex-default date" style='justify-content: flex-start;'>
                                <div class="tag ellipsis">
                                    <span 
                                        class="tag-red"  
                                        v-if="article.type !='subject'" v-html="article.tags"
                                    ></span>
                                    <span v-html="article.source"></span>
                                </div>
                                <time>{{getDate(article.date) | dateCompared}}</time>
                            </div>
                        </div> 
                        <div v-else>
                            <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                            <div class="pic-wrap" v-if="article.images">
                                <img :src="article.images[0]" alt="">
                                <div class="images-label" v-if="article.type === 'image'">{{article.medias && article.medias.length>0 ?article.medias.length : 0}}图</div>
                            </div>
                            <!-- <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.title}}</div> -->
                            <div class="description" v-html="article.description"></div>
                            <div class="flex-default date" style='justify-content: flex-start;'>
                                <div class="tag ellipsis">
                                    <span 
                                        class="tag-red"  
                                        v-if="article.type !='subject'" v-html="article.tags"
                                    ></span>
                                    <span v-html="article.source"></span>
                                </div>
                                <time>{{getDate(article.date) | dateCompared}}</time>
                            </div>
                        </div>
                    </div>
                    <!-- 图集 -->
                    <!-- <div v-else-if="article.type === 'image'">
                        <div class="title" v-html="article.title"></div>
                        <div class="flex images-list">
                            <div class="images" v-for="img in article.medias.slice(0,4)" :style="{backgroundImage: 'url(' + img.image + ')'}"></div>
                            <div class="images-label" v-if="article.medias.length>3">{{article.medias.length}}图</div>
                        </div>
                    </div> -->
                    <!-- 左文右图 -->
                    <template v-else>
                        <div class="info" style='width:100%'>
                            <div class="title"><span class="tag_label_2" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                            <div class="flex date">
                                <div class="tag ellipsis" style=' justify-content: flex-start'>
                                    <span 
                                        class="tag-red"  
                                        v-if="article.type !='subject'" v-html="article.tags"
                                    ></span>
                                    <span v-html="article.source"></span>
                                </div>
                                <!-- <time>{{getDate(article.date) | dateCompared}}</time> -->
                                <time>{{getDate(article.date) | dateCompared}}</time>
                            </div>
                        </div>
                         <div class="thumbnail" :style="{backgroundImage: 'url(' + article.images[0] + ')'}" v-if="article.images">
                            <i :class="[article.type+'-icon']"></i>
                        </div>
                    </template>
                </li>
            </ul>
            <footer @click="getArticles(item.id, index)" v-if="item.page.next*1 <= item.page.last*1">加载更多</footer>
        </section>
    </div>
</template>

<script>
    import wx from '../services/weChatShare'
    import { Toast } from 'mint-ui'
    import { intfc_prefix_common } from 'constants/project'

    export default {
        data () {
            return {
                data: {},
                blocks: [], 
            }
        },

        created () {
            this.getInit(this.$route.params.id)
        },

         
        methods: {
            getInit (id, size=5) {
                this.$axios.get(`${intfc_prefix_common}/api/v2/subjects/${id}?size=${size}`)
                    .then(res=> {
                        const result = res.item
                        if (res.code === 0) {
                            this.data = result
                            this.blocks = result.blocks
                            // 微信分享
                            wx({
                                title: result.title,
                                // imgUrl: result.image
                            },this)

                            // 存储唤醒的数据
                            // this.$store.dispatch('saveData', result)
                        }else {
                            Toast(res.msg)
                        }
                    })
            },
            toggleBlock (index,e) {//跳转到指定区块
                var id = this.generateElementId(index)
                document.getElementById(id).scrollIntoView(true)
            },
            getArticles (id, index) {
                let size = 5;
                if(this.data.blockType == 1) {
                    size = 20;
                }
                const pageToken = this.blocks[index].page.next * 1
                const pageLast = this.blocks[index].page.last * 1
                // 最后一页无需加载
                if (pageToken > pageLast) return false
                this.$axios.get(`${intfc_prefix_common}/api/v2/blocks/${id}?size=${size}&pageToken=${pageToken}`)
                    .then(res=> {
                        const result = res.items
                        if (res.code === 0) {
                            this.blocks[index].articles = [...this.blocks[index].articles, ...result]
                            this.blocks[index].page.next++
                        }
                    })
            },

            getDate: (date) => {
                return date.slice(0, -2) + ':00'
            },

            getTime (time) {
                let result = ''
                if (time) {
                    result = time.substring(0,10) + ' ' + time.substring(11,16)
                }
                return result
            },

            getCount (count) {
                let result = 0
                if (count > 0) {
                    result = count
                    if (count > 999999) {
                        result = count.substring(0,count.length - 4) + '万'
                        if (count > 99999999) {
                            result = '过亿'
                        }
                    }
                }
                return result
            },

            goPath (article) {
                window.location.href = article.shareUrl
            },

            generateElementId(i) {//此处通过v-bind响应，然后返回id的值。
                return "blockElementId" + i
            },
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin"
    @import "~src/stylus/list"
    
    .wrapper
        .img-frame-small
            margin 0 0px 0px
            height 115px
            position relative
            overflow hidden
            .img-bac
                width 100%
                height 100%    
        background-size cover !important
        background-position center center !important
        position relative
        font-family: 'FZBIAOYSK','FZBIAOYSKIOS','FZBIAOYSKIOS BOLD', 'PingFangSC-Regular', '微软雅黑', sans-serif;
        .top-pic
            width 750px
            max-height 469px
            overflow hidden
            img
                width 100%
                display block
        .title-area
            margin-top 32px
            padding 0 30px
            h3 
                line-height 62px 
                color #222
                font-size 44px
            .description 
                margin-top 30px
                color #666666
                font-size 28px
                line-height 40px
        section 
            margin-top 60px
        
</style>

<style type="text/css">
    .lable-ul {
      margin: 20px auto;
      width: 100%;
      border-radius: 10px;
      overflow: hidden;
      background: white;
    }

    .label-ul-content {
      padding: 10px 20px 15px 0;
      overflow-y: auto;
    }

    .label-ul-content ul {
      margin: 0;
      padding: 0;
      margin-bottom: 20px;
      overflow: hidden;
      padding-top: 1px;
      list-style:none;
    }
    .label-ul-content ul li {
      border: 1px solid #aaaaaa;   /* 必须 */
      text-align: center;            /* 必须 */
      margin: 20px 10px 10px 20px;
      display: inline-block;
      min-height: 66px;
      border-radius: 33px;
    }
    
    .label-ul-content ul li  a {
        margin: 0px 30px 0px 30px;
        font-size: 32px;
        line-height: 66px;
        height: 66px;
        color: #555;
    }
  </style>
 


// WEBPACK FOOTER //
// page-topic2.vue?32bc037b